(function () {
  const TOTAL_STEPS = 4;

  const frequencyMap = {
    'once-daily': { size: 20, purchase: 'one-time',  emphasis: false },
    'twice-daily': { size: 20, purchase: 'subscribe', emphasis: false },
    'three-plus':  { size: 50, purchase: 'subscribe', emphasis: true  },
    'weekends':    { size: 20, purchase: 'one-time',  emphasis: false },
    'varies':      { size: 20, purchase: 'one-time',  emphasis: false }
  };

  const vibeMap = {
    'everything': { baseKey: 'starter_pack',   fixedSize: true  },
    'smooth':     { baseKey: 'vanilla',        fixedSize: true  },
    'creamy':     { baseKey: 'french_vanilla', fixedSize: false },
    'nutty':      { baseKey: 'hazelnut',       fixedSize: false },
    'cozy':       { baseKey: 'caramel',        fixedSize: false }
  };

  const occasionCopy = {
    'desk':     { pill: 'Built for focus',  copy: 'Keeps up with back-to-back meetings' },
    'commute':  { pill: 'Built for motion', copy: 'Built for the commute. And the one after that' },
    'outdoors': { pill: 'No limits',        copy: 'Flavor that keeps up' },
    'home':     { pill: 'Own your morning', copy: 'Your morning. Your pace. Your flavor' }
  };

  function computeResultKey(state) {
    const frequencyConfig = frequencyMap[state.frequency] || frequencyMap['once-daily'];

    if (state.sugar === 'sugar-free') {
      return { key: 'sf_caramel_50', purchase: frequencyConfig.purchase, emphasis: frequencyConfig.emphasis };
    }

    const vibeConfig = vibeMap[state.vibe];
    if (!vibeConfig) return null;

    let key;
    if (vibeConfig.fixedSize) {
      key = vibeConfig.baseKey === 'vanilla' ? 'vanilla_50' : vibeConfig.baseKey;
    } else {
      key = frequencyConfig.size === 50 ? vibeConfig.baseKey + '_50' : vibeConfig.baseKey + '_20';
    }

    return { key, purchase: frequencyConfig.purchase, emphasis: frequencyConfig.emphasis };
  }

  function initQuiz(overlay) {
    const state = { frequency: null, occasion: null, sugar: null, vibe: null };
    let currentStep = 0;

    const modal               = overlay.querySelector('.quiz-flavor-finder__modal');
    const closeBtn            = overlay.querySelector('[data-quiz-close]');
    const stepsContainer      = overlay.querySelector('[data-quiz-steps]');
    const resultsContainer    = overlay.querySelector('[data-quiz-results]');
    const stepLabelEl         = overlay.querySelector('[data-quiz-step-label]');
    const progressFill        = overlay.querySelector('[data-quiz-progress-fill]');
    const nextBtn             = overlay.querySelector('[data-quiz-next]');
    const backBtn             = overlay.querySelector('[data-quiz-back]');
    const stepFooterEl        = overlay.querySelector('[data-quiz-footer]');
    const occasionPillEl      = overlay.querySelector('[data-occasion-pill]');
    const occasionCopyEl      = overlay.querySelector('[data-occasion-copy]');
    const restartBtn          = overlay.querySelector('[data-quiz-restart]');
    const secondaryCardSlot   = overlay.querySelector('[data-quiz-secondary-card-slot]');
    const optionsLink         = overlay.querySelector('[data-quiz-options-link]');
    const stickyFooter        = overlay.querySelector('[data-quiz-sticky-footer]');
    const productsDataEl      = overlay.querySelector('[data-quiz-products]');
    let quizProducts          = {};
    try { quizProducts = JSON.parse(productsDataEl ? productsDataEl.textContent : '{}'); } catch(e) {}
    const atcForm             = overlay.querySelector('[data-quiz-atc-form]');
    const sellingPlanInput    = atcForm ? atcForm.querySelector('[data-quiz-selling-plan]') : null;
    const toggleBtns          = overlay.querySelectorAll('[data-purchase]');
    const progressTrack       = overlay.querySelector('[data-quiz-progress-track]');
    const atcIdInput          = atcForm ? atcForm.querySelector('[name="id"]') : null;
    const atcTitleSpan        = overlay.querySelector('[data-quiz-atc-title]');
    const saveForm            = overlay.querySelector('#quiz-newsletter-form');
    const saveInput           = saveForm ? saveForm.querySelector('[name="contact[email]"]') : null;
    const saveBtn             = saveForm ? saveForm.querySelector('.quiz-flavor-finder__save-btn') : null;

    function openModal() {
      overlay.removeAttribute('hidden');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (modal) modal.scrollTop = 0;
    }

    function closeModal() {
      overlay.setAttribute('hidden', '');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function updateProgress(stepNumber) {
      const progressPercent = Math.round((stepNumber / TOTAL_STEPS) * 100);
      if (progressFill) progressFill.style.width = progressPercent + '%';
      if (stepLabelEl) stepLabelEl.textContent = 'Step ' + stepNumber + ' of ' + TOTAL_STEPS;
    }

    function updateFooterForStep(stepNumber) {
      if (backBtn) backBtn.hidden = (stepNumber === 1);
      if (nextBtn) {
        nextBtn.textContent = (stepNumber === TOTAL_STEPS) ? 'See my results' : 'Next';
      }
    }

    function showStep(stepNumber) {
      const goingBack = currentStep > 0 && stepNumber < currentStep;
      overlay.querySelectorAll('.quiz-flavor-finder__step').forEach(el => {
        el.classList.remove('is-active', 'is-back');
      });
      const targetStep = overlay.querySelector('[data-step="' + stepNumber + '"]');
      if (targetStep) {
        if (goingBack) targetStep.classList.add('is-back');
        targetStep.classList.add('is-active');
      }
      currentStep = stepNumber;
      updateProgress(stepNumber);
      if (nextBtn) nextBtn.disabled = true;
      const preSelectedOption = overlay.querySelector('.quiz-flavor-finder__step[data-step="' + stepNumber + '"] .quiz-flavor-finder__option.is-selected');
      if (preSelectedOption && nextBtn) nextBtn.disabled = false;
      if (stepFooterEl) stepFooterEl.removeAttribute('hidden');
      updateFooterForStep(stepNumber);
      if (stickyFooter) stickyFooter.hidden = true;
      if (modal) modal.scrollTop = 0;
    }

    function handleOptionClick(clickedOption) {
      const stepNumber = parseInt(clickedOption.dataset.step, 10);
      overlay.querySelectorAll('.quiz-flavor-finder__step[data-step="' + stepNumber + '"] .quiz-flavor-finder__option').forEach(el => {
        el.classList.remove('is-selected');
      });
      clickedOption.classList.add('is-selected');
      if (nextBtn) nextBtn.disabled = false;
    }

    function handleBack() {
      if (currentStep <= 1) return;
      showStep(currentStep - 1);
    }

    function handleNext() {
      const selectedOption = overlay.querySelector('.quiz-flavor-finder__step[data-step="' + currentStep + '"] .quiz-flavor-finder__option.is-selected');
      const selectedAnswer = selectedOption ? selectedOption.dataset.answer : null;
      if (!selectedAnswer) return;

      if (currentStep === 1) state.frequency = selectedAnswer;
      if (currentStep === 2) state.occasion  = selectedAnswer;
      if (currentStep === 3) state.sugar     = selectedAnswer;
      if (currentStep === 4) state.vibe      = selectedAnswer;

      let quizResult;
      if (currentStep === 3 && selectedAnswer === 'sugar-free') {
        quizResult = computeResultKey(state);
        if (quizResult) showResults(quizResult);
        return;
      }

      if (currentStep < TOTAL_STEPS) {
        showStep(currentStep + 1);
      } else {
        quizResult = computeResultKey(state);
        if (quizResult) showResults(quizResult);
      }
    }

    function showResults(quizResult) {
      if (stepsContainer) stepsContainer.hidden = true;
      if (stepFooterEl) stepFooterEl.setAttribute('hidden', '');

      updateProgress(TOTAL_STEPS);

      if (stepLabelEl) stepLabelEl.hidden = true;
      if (progressTrack) progressTrack.hidden = true;
      if (modal) modal.classList.add('is-results');

      const productData = quizProducts[quizResult.key];
      if (secondaryCardSlot) {
        const existingSecondaryCard = secondaryCardSlot.querySelector('[data-quiz-selectable]');
        if (existingSecondaryCard) existingSecondaryCard.remove();
      }
      if (productData && secondaryCardSlot) {
        const cardTemplate = document.getElementById('quiz-result-card-tpl');
        if (cardTemplate) {
          const secondaryCard = cardTemplate.content.cloneNode(true).firstElementChild;
          secondaryCard.dataset.variantId     = String(productData.variantId || '');
          secondaryCard.dataset.productTitle  = productData.title || '';
          secondaryCard.dataset.subscribePlan = String(productData.subscribePlan || '');
          if (productData.imageUrl) {
            const productImage = document.createElement('img');
            productImage.src     = productData.imageUrl;
            productImage.loading = 'lazy';
            productImage.alt     = productData.imageAlt || '';
            secondaryCard.querySelector('.quiz-flavor-finder__result-img').appendChild(productImage);
          }
          secondaryCard.querySelector('.quiz-flavor-finder__result-title').textContent = productData.title || '';
          secondaryCard.querySelector('.quiz-flavor-finder__result-price').textContent = productData.price || '';
          secondaryCardSlot.appendChild(secondaryCard);
        }
      }

      const occasionContent = occasionCopy[state.occasion];
      if (occasionContent) {
        if (occasionPillEl) occasionPillEl.textContent = occasionContent.pill;
        if (occasionCopyEl) occasionCopyEl.textContent = occasionContent.copy;
      }

      resultsContainer.removeAttribute('hidden');
      if (stickyFooter) stickyFooter.hidden = false;

      const primaryResultCard = overlay.querySelector('[data-quiz-selectable]');
      if (primaryResultCard) {
        overlay.querySelectorAll('[data-quiz-selectable]').forEach(c => c.classList.remove('is-selected'));
        primaryResultCard.classList.add('is-selected');
        if (atcIdInput) atcIdInput.value = primaryResultCard.dataset.variantId || '';
        if (atcTitleSpan) atcTitleSpan.textContent = shortTitle(primaryResultCard.dataset.productTitle) || 'Your Match';
        if (atcForm) atcForm.dataset.subscribePlan = primaryResultCard.dataset.subscribePlan || '';
      }

      if (optionsLink && productData) {
        optionsLink.href   = productData.url || '#';
        optionsLink.hidden = false;
      }

      if (quizResult.purchase === 'subscribe') {
        setActiveTab('subscribe');
      } else {
        setActiveTab('onetime');
      }

      updateToggleForCard(primaryResultCard);

      try { sessionStorage.setItem('quiz-result-state', JSON.stringify({ occasion: state.occasion, result: quizResult })); } catch(e) {}

      if (modal) modal.scrollTop = 0;
    }

    function setActiveTab(mode) {
      toggleBtns.forEach(btn => {
        btn.classList.toggle('is-active', btn.dataset.purchase === mode);
      });
      if (sellingPlanInput && atcForm) {
        sellingPlanInput.value = (mode === 'subscribe') ? (atcForm.dataset.subscribePlan || '') : '';
      }
    }

    function shortTitle(title) {
      return (title || '').split(' ').slice(0, 3).join(' ');
    }

    function updateToggleForCard(selectedCard) {
      const subscribeBtn = overlay.querySelector('[data-purchase="subscribe"]');
      if (!subscribeBtn) return;
      if (selectedCard && selectedCard.dataset.subscribePlan) {
        subscribeBtn.classList.remove('is-disabled');
        setActiveTab('subscribe');
      } else {
        subscribeBtn.classList.add('is-disabled');
        setActiveTab('onetime');
      }
    }

    /* ── Event listeners ── */

    toggleBtns.forEach(btn => {
      btn.addEventListener('click', () => setActiveTab(btn.dataset.purchase));
    });

    if (saveInput && saveBtn) {
      saveInput.addEventListener('input', () => {
        saveBtn.classList.toggle('is-ready', saveInput.validity.valid && saveInput.value.trim() !== '');
      });
    }

    if (saveForm) {
      saveForm.addEventListener('submit', e => {
        if (!saveInput || !saveInput.validity.valid) {
          e.preventDefault();
          if (saveInput) saveInput.reportValidity();
          return;
        }
        if (saveBtn) {
          saveBtn.classList.add('is-loading');
          saveBtn.disabled = true;
        }
      });
    }

    document.querySelectorAll('[data-quiz-open]').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        openModal();
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (backBtn)  backBtn.addEventListener('click', handleBack);
    if (nextBtn)  nextBtn.addEventListener('click', handleNext);

    /* Merged overlay click handler — backdrop close, option select, card select */
    overlay.addEventListener('click', e => {
      if (e.target === overlay) { closeModal(); return; }

      const clickedOption = e.target.closest('.quiz-flavor-finder__option');
      if (clickedOption) { handleOptionClick(clickedOption); return; }

      const selectedCard = e.target.closest('[data-quiz-selectable]');
      if (!selectedCard) return;
      overlay.querySelectorAll('[data-quiz-selectable]').forEach(c => c.classList.remove('is-selected'));
      selectedCard.classList.add('is-selected');
      if (atcIdInput) atcIdInput.value = selectedCard.dataset.variantId || '';
      if (atcTitleSpan) atcTitleSpan.textContent = shortTitle(selectedCard.dataset.productTitle) || 'Your Match';
      if (atcForm) atcForm.dataset.subscribePlan = selectedCard.dataset.subscribePlan || '';
      updateToggleForCard(selectedCard);
      const activeToggle = overlay.querySelector('[data-purchase].is-active');
      if (sellingPlanInput) {
        sellingPlanInput.value = (activeToggle && activeToggle.dataset.purchase === 'subscribe') ? (selectedCard.dataset.subscribePlan || '') : '';
      }
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) closeModal();
    });

    if (restartBtn) {
      restartBtn.addEventListener('click', () => {
        state.frequency = null;
        state.occasion  = null;
        state.sugar     = null;
        state.vibe      = null;

        resultsContainer.setAttribute('hidden', '');
        if (secondaryCardSlot) {
          const existingSecondaryCard = secondaryCardSlot.querySelector('[data-quiz-selectable]');
          if (existingSecondaryCard) existingSecondaryCard.remove();
        }
        if (optionsLink) { optionsLink.hidden = true; optionsLink.href = '#'; }
        if (stickyFooter) stickyFooter.hidden = true;
        if (stepsContainer) stepsContainer.hidden = false;
        overlay.querySelectorAll('.quiz-flavor-finder__option.is-selected').forEach(el => {
          el.classList.remove('is-selected');
        });
        const everythingBtn = overlay.querySelector('.quiz-flavor-finder__option--featured');
        if (everythingBtn) everythingBtn.classList.add('is-selected');
        if (stepLabelEl) stepLabelEl.hidden = false;
        if (progressTrack) progressTrack.hidden = false;
        if (modal) modal.classList.remove('is-results');
        const subscribeBtn = overlay.querySelector('[data-purchase="subscribe"]');
        if (subscribeBtn) subscribeBtn.classList.remove('is-disabled');
        overlay.querySelectorAll('[data-quiz-selectable]').forEach(el => el.classList.remove('is-selected'));
        /* Reset step counter so showStep(1) animates forward, not back */
        currentStep = 0;
        showStep(1);
      });
    }

    showStep(1);

    /* Re-open with results after Shopify newsletter redirect */
    const pageUrlParams = new URLSearchParams(window.location.search);
    if (pageUrlParams.get('customer_posted') === 'true') {
      let savedQuizState = null;
      try { savedQuizState = JSON.parse(sessionStorage.getItem('quiz-result-state')); } catch(e) {}
      sessionStorage.removeItem('quiz-result-state');
      if (savedQuizState && savedQuizState.result) {
        state.occasion = savedQuizState.occasion || null;
        openModal();
        showResults(savedQuizState.result);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const overlay = document.querySelector('[data-quiz-overlay]');
    if (overlay) initQuiz(overlay);
  });
})();
